export function showAlerts(id, triggerUpdate) {
  const $candidatesNotifications = $('#candidate-suggestions-notification');
  const alertsTemplate = $('#alerts')[0].content;

  const alertToShow = $(alertsTemplate).find(`#${id}`)[0].cloneNode(true);
  $candidatesNotifications.append(alertToShow);

  if (triggerUpdate) $(document).trigger('dom-update');
}
export function resetFormSync(trigger) {
  const form = $('#candidate-suggestions-form');
  const buttons = form.find('button');

  $(trigger).find('.spinner-small').remove();
  $(trigger).find('i').removeClass('is-hidden');

  // Re-enable all buttons when form is submitted and promise is resolved
  buttons.each((_, elem) => {
    elem.removeAttribute('disabled');
    elem.classList.toggle('is-disabled');
  });
}

export function syncFormWorker() {
  const form = $('#candidate-suggestions-form');
  form.submit((e) => {
    const trigger = e.originalEvent?.submitter;
    const buttons = form.find('button');
    const triggerIcon = $(trigger).find('i');

    // Hide plus icon and show spinner on trigger.
    triggerIcon.addClass('is-hidden');
    triggerIcon.after('<div class="spinner-small color-inherit mr-[4px]"></div>');

    // Disable all buttons when form is submitted until promise is resolved
    buttons.each((_, elem) => {
      elem.setAttribute('disabled', 'disabled');
      elem.classList.toggle('is-disabled');
    });

    window.suggestionPromise = new Promise((resolve) => {
      window.resolveSuggestion = (source) => {
        resolve({
          source, trigger,
        });
      };
    });
  });
}

export async function suggestCandidates({ html }) {
  const $loading = $('#candidate-suggestions-loading');
  const $table = $('#candidate-suggestions-table');
  const $tbody = $table.find('tbody');
  const $loadMore = $('#load-more-suggestions');
  const $loadMoreText = $('#load-more-suggestions-text');
  const $loadingMoreText = $('#loading-more-suggestions-text');
  const $noResultsTable = $('#no-results-table');
  let sourcePromise;

  $loading.remove();

  if (window.suggestionPromise) {
    const { source, trigger } = await window.suggestionPromise;
    sourcePromise = source;
    resetFormSync(trigger);
  }

  if (html === '') {
    const tableHidden = $table.hasClass('is-hidden') || !$table.find('tbody tr:not(.is-hidden):not([data-table-row="remove-row"])').length;

    if (tableHidden) {
      $table.addClass('is-hidden');
      $noResultsTable.removeClass('is-hidden');
    }
    else {
      if (sourcePromise === 'moreSuggestions') {
        showAlerts('no-more-suggestions');
      }
      $loadMore.addClass('is-disabled');
      $loadMoreText.removeClass('is-hidden');
    }

    $loadMoreText.removeClass('is-hidden');
    $loadingMoreText.addClass('is-hidden');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  } else {
    // Get the last element of table before append
    const lastElem = $table.find('tbody tr:last-of-type')[0];

    $table.removeClass('is-hidden');
    $tbody.append(html);
    // Scroll to the next element of previous last element (if it has any when new suggestions are requested)
    if (sourcePromise === 'moreSuggestions') {
      lastElem?.nextElementSibling?.scrollIntoView(true);
    }
    $loadMore.removeClass('is-disabled');
    $loadMoreText.removeClass('is-hidden');
    $loadingMoreText.addClass('is-hidden');
  }

  $(document).trigger('dom-update');
}

export function suggestCandidatesError() {
  const $loading = $('#candidate-suggestions-loading');

  if ($loading.length > 0) {
    $loading.remove();
  }

  showAlerts('candidate-suggestions-error', true);
}
